
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-ia",
      function () {
        return require("private-next-pages/magnets-ia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magnets-ia"])
      });
    }
  